<template>
  <div class="login-container">
    <div class="login-top">
      <div class="login-top-bg">
        <div class="login-top-content">
          <div class="live-name">{{channelInfo.title}}</div>
          <div class="live-time">直播时间：{{channelInfo.begin_time}}</div>
          <div class="login-main clearfix">
            <div class="live-img">
              <el-image fit="cover" class="live-img-src" :src="channelInfo.cover? channelInfo.cover:'https://live-oss.busionline.com/assets/images/channel_default.png'"></el-image>
            </div>
            <div class="login-entrance">
              <div class="login-entrance-title">登录</div>
              <div class="login-form">
                <el-input v-model="user_id" placeholder="请输入账号" @keypress.native.enter="handleLogin" name="user_id" type="text" tabindex="1" auto-complete="on">
                  <i slot="prefix" class="iconfont icon-icon_login_zhanghao"></i>
                </el-input>
                <el-button class="login-submit" :loading="loading" type="primary" @click.native.prevent="handleLogin">登录</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="live-summary">
      <div class="live-summary-title">直播内容介绍</div>
      <div class="live-summary-content">{{channelInfo.intro}}</div>
    </div>
  </div>
</template>

<script>
  import watchApi from '@/api/watch'
  import { setStudentId } from '@/utils/auth'
  export default {
    name: 'watchLogin',
    data() {
      return {
        user_id: '',
        loading: false,
        channelInfo: {},
        channelId: ''
      }
    },
    created() {
      this.channelId = this.$route.query.channel_id
      if(this.channelId){
        this.getChannelDetail()
      }
    },
    methods: {
      getChannelDetail() {
        watchApi.getChannelDetail(this.channelId).then(res => {
          if (res.code === 0) {
            this.channelInfo = res.data
          }
          this.loading = false
        }).catch(res => {
          this.loading = false
        })
      },
      handleLogin() {
        if(!this.user_id){
          this.$message.warning('请输入账号！')
          return
        }
        // let reg = '/^[A-Za-z0-9][A-Za-z0-9\\-\\_]+$/'
        // if(!this.user_id.match(reg)){
        //   this.$message.warning('用户账号只能为字母或数字开头的字母、数字、-、_的组合')
        //   return
        // }
        this.loading = true
        let loginForm = {
          user_id: this.user_id
        }
        watchApi.validateWhitelist(this.channelId,loginForm).then(res => {
          if (res.code === 0) {
            setStudentId(res.data.session_id)
            this.$router.push({
              path: '/watch',
              query: {channel_id: res.data.channel_id}
            })
          }
          this.loading = false
        }).catch(res => {
          this.loading = false
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .login-container {
    width: 100%;
    height: 100%;
    background: #F7F8FA;
    .login-top{
      width: 100%;
      height: 597px;
      overflow: hidden;
      margin-bottom: 24px;
      .login-top-bg{
        width: 100%;
        height: 100%;
        padding-top: 80px;
        background: url('https://chuangpei-prod.oss-cn-hangzhou.aliyuncs.com/images/bg_login.png') no-repeat top left;
        .login-top-content{
          width: 1200px;
          margin: 0 auto;
          .live-name{
            font-size: 24px;
            color: #fff;
            line-height: 24px;
            margin-bottom: 16px;
            font-weight: bold;
          }
          .live-time{
            font-size: 14px;
            color: #fff;
            line-height: 14px;
            margin-bottom: 16px;
          }
          .login-main {
            .live-img {
              float: left;
              width: 680px;
              height: 383px;
              border-radius: 8px 8px 0px 0px;
              margin-right: 24px;
              .live-img-src {
                display: block;
                width: 100%;
                height: 100%;
                border-radius: 8px 8px 0px 0px;
              }
            }
            .login-entrance {
              float: left;
              width: 496px;
              height: 383px;
              background: #FFFFFF linear-gradient(180deg, #DAEAFF 0%, #FFFFFF 30%);
              box-shadow: 0px 14px 40px 0px rgba(0, 95, 255, 0.64);
              border-radius: 8px;
              padding: 82px 48px;
              box-sizing: border-box;
              .login-entrance-title {
                font-size: 28px;
                font-weight: bold;
                color: #171717;
                line-height: 24px;
                margin-bottom: 48px;
                text-align: center;
              }

              /*::v-deep .el-form {*/
              /*  .el-form-item {*/
              /*    margin-bottom: 24px;*/
              /*    .el-form-item__label {*/
              /*      font-size: 16px;*/
              /*      font-weight: 500;*/
              /*      color: #171717;*/
              /*      &:before {*/
              /*        display: none;*/
              /*      }*/
              /*    }*/

              /*    .el-input--prefix{*/
              /*      .el-input__inner{*/
              /*        padding-left: 40px;*/
              /*      }*/
              /*      .el-input__prefix{*/
              /*        left: 12px;*/
              /*        top: 3px;*/
              /*        .iconfont{*/
              /*          color: #A3A4B3;*/
              /*        }*/
              /*      }*/
              /*    }*/
              /*    .el-input {*/
              /*      input:-webkit-autofill {*/
              /*        -webkit-box-shadow: 0 0 0 1000px white inset; !**通过边框阴影遮挡住背景*!*/
              /*        -webkit-text-fill-color: #333;*/
              /*      }*/
              /*      .el-input__inner {*/
              /*        border-radius: 4px;*/
              /*        height: 48px;*/
              /*        border: 1px solid #D8DCE6;*/
              /*        &::placeholder {*/
              /*          color: #909399;*/
              /*        }*/

              /*        &:hover {*/
              /*          border-color: #1678FF;*/
              /*        }*/
              /*      }*/
              /*    }*/

              /*    &.is-error {*/
              /*      .el-input {*/
              /*        .el-input__inner {*/
              /*          border-color: #E94D41;*/
              /*        }*/
              /*      }*/
              /*    }*/
              /*  }*/

              /*  .el-button {*/
              /*    width: 100%;*/
              /*    height: 48px;*/
              /*    margin-top: 26px;*/
              /*    background: #1678FF;*/
              /*    border-radius: 4px;*/
              /*    font-size: 16px;*/
              /*    color: #fff;*/
              /*    letter-spacing: 4px;*/

              /*    .el-icon-loading {*/
              /*      font-size: 16px;*/
              /*    }*/

              /*    &:hover {*/
              /*      opacity: 0.75;*/
              /*    }*/
              /*  }*/
              /*}*/


              ::v-deep .el-input--prefix{
                .el-input__inner{
                  padding-left: 40px;
                }
                .el-input__prefix{
                  left: 12px;
                  top: 15px;
                  .iconfont{
                    color: #A3A4B3;
                  }
                }
              }
              ::v-deep .el-input {
                input:-webkit-autofill {
                  -webkit-box-shadow: 0 0 0 1000px white inset; /**通过边框阴影遮挡住背景*/
                  -webkit-text-fill-color: #333;
                }
                .el-input__inner {
                  border-radius: 4px;
                  height: 48px;
                  border: 1px solid #D8DCE6;
                  &::placeholder {
                    color: #909399;
                  }

                  &:hover {
                    border-color: #1678FF;
                  }
                }
              }
              .el-button {
                width: 100%;
                height: 48px;
                margin-top: 26px;
                background: #1678FF;
                border-radius: 4px;
                font-size: 16px;
                color: #fff;
                letter-spacing: 4px;

                .el-icon-loading {
                  font-size: 16px;
                }

                &:hover {
                  opacity: 0.75;
                }
              }
            }
          }
        }
      }
    }
    .live-summary{
      width: 1200px;
      margin: 0 auto;
      background-color: #fff;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      padding: 32px;
      box-sizing: border-box;
      .live-summary-title{
        font-size: 18px;
        line-height: 18px;
        color: #333333;
        font-weight: 500;
        padding-left: 12px;
        border-left: 3px solid #1678FF;
        margin-bottom: 24px;
      }
      .live-summary-content{
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 26px;
      }
    }
  }
</style>
